import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NotificationService } from '../../../ff/services/notification/notification.service';
import { AuthenticationService } from '../../../ff/services/authentication/authentication.service';
import { SessionTimeoutService } from '../../../ff/services/session_timeout/session_timeout.service';

@Component({
  selector: 'ff-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  notifications;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [
  //   {
  //   title: 'View Profile',
  //   uri: 'profile_button',
  //   actions: [{
  //     mime_type: 'action/definition',
  //     action: 'visualize:user_profile',
  //   }],
  // },
  {
    title: 'Edit Account',
    uri: 'edit_account_button',
    actions: [
      {
        mime_type: 'action/definition',
        action: 'authentication/edit_user',
      },
    ],
  },
  {
    title: 'Change Password',
    uri: 'change_password_button',
    actions: [
      {
        mime_type: 'action/definition',
        action: 'navigate_to_url',
        parameters: [{
          mime_type: 'url/definition',
          path: `/application/portal/change_password`,
          target: '_self',
        }],
      },
    ],
  },
  { title: 'Log out', uri: 'logout_button' },
];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private authService: AuthenticationService,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private notification_service: NotificationService,
              private session_timeout: SessionTimeoutService) {
    this.notifications = this.notification_service.notifications_dataset.data;
  }

  remaining_time_s() {
    return this.session_timeout.remaining_time_s;
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    this.user = this.authService.current_user || {};

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
}
